(() => {
  const targets = new Map([
    ['hochflor-reinigungstuch', '1'],
    ['innenraum-zitrusbaum', '500 ML'],
    ['caravan-glasreiniger', '500 ML'],
    ['insekten-ciao-insektenentferner', '500 ML']
  ]);
  const variantIds = new Map([
    ['hochflor-reinigungstuch', '40074327785495'],
    ['innenraum-zitrusbaum', '51775383961867'],
    ['caravan-glasreiniger', '51932895609099'],
    ['insekten-ciao-insektenentferner', '51932964618507']
  ]);
  const labels = new Map([
    ['hochflor-reinigungstuch', '1 Stück'],
    ['innenraum-zitrusbaum', '500 ml'],
    ['caravan-glasreiniger', '500 ml'],
    ['insekten-ciao-insektenentferner', '500 ml']
  ]);
  const titles = new Map([
    ['hochflor-reinigungstuch', 'Hochflor-Tuch'],
    ['innenraum-zitrusbaum', 'Innenraum Reiniger'],
    ['caravan-glasreiniger', 'Fenster Reiniger'],
    ['insekten-ciao-insektenentferner', 'Insekten Entferner']
  ]);
  const rootSelector = '#wizz4-cart-drawer';
  const cardSelector = '.wizz-upsell-productBox-custom';
  const selectSelector = '.w4-snap-upsell-expanded__variant-select, [id="w4-select-upsell"]';
  const styleId = 'woshup-snap-fixed-variants-style';
  if (document.getElementById(styleId)) return;
  const style = document.createElement('style');
  style.id = styleId;
  style.textContent =
    rootSelector + ' [data-woshup-variant-label-wrap] > :not(.woshup-variant-label) { display: none !important; }' +
    rootSelector + ' select[data-woshup-fixed-variant] { display: none !important; }' +
    rootSelector + ' [data-woshup-variant-label-wrap] { display: block !important; height: auto !important; min-height: 0 !important; padding: 0 !important; margin: 0 !important; border: 0 !important; background: transparent !important; box-shadow: none !important; }' +
    rootSelector + ' .woshup-variant-label { display: block; color: #555; font-size: 12px; line-height: 16px; font-weight: 400; text-align: center; }' +
    rootSelector + ' [data-woshup-upsell-title] { white-space: normal !important; overflow: hidden !important; text-overflow: clip !important; display: -webkit-box !important; -webkit-box-orient: vertical !important; -webkit-line-clamp: 2 !important; line-height: 1.25 !important; height: auto !important; max-height: none !important; }' +
    rootSelector + ' .w4-snap-upsell-beside-mobile-card [data-woshup-upsell-title] { min-height: 2.5em !important; }' +
    rootSelector + ' .w4-snap-upsell-beside-mobile-card { position: relative; }' +
    rootSelector + ' .woshup-mobile-discount-badge { position: absolute; top: 6px; left: 6px; z-index: 2; padding: 2px 6px; border-radius: 4px; font-size: 11px; font-weight: 600; line-height: 14px; pointer-events: none; }' +
    rootSelector + ' [data-woshup-mobile-discount] > :not(.woshup-mobile-prices) { display: none !important; }' +
    rootSelector + ' .woshup-mobile-prices { display: flex; flex-direction: column; align-items: center; gap: 1px; line-height: 18px; white-space: nowrap; }' +
    rootSelector + ' .woshup-mobile-compare { font-size: 11px; font-weight: 400; color: #666; text-decoration: line-through; }' +
    rootSelector + ' .woshup-mobile-price { font-size: 14px; font-weight: 700; color: #000; }' +
    rootSelector + ' [data-woshup-variant-missing] { display: none !important; }';
  document.head.appendChild(style);
  const setValue = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
  let scheduled = false;
  const normalize = value => value.trim().replace(/\s+/g, '').toLowerCase();
  function syncMobileDiscounts(root) {
    const desktop = new Map(Array.from(root.querySelectorAll('.w4-snap-upsell-expanded__card')).map(card => [card.querySelector('a[href*="/products/"]')?.href, card]));
    for (const card of root.querySelectorAll('.w4-snap-upsell-beside-mobile-card')) {
      const source = desktop.get(card.querySelector('a[href*="/products/"]')?.href);
      const priceBox = card.querySelector('.wizz-upsell-productInfor-content-priceBox-custom');
      if (!priceBox) continue;
      const sourceBadge = source?.querySelector('.w4-snap-upsell-discount-badge');
      const compare = source?.querySelector('.w4-snap-upsell-expanded__compare')?.textContent.trim();
      const price = source?.querySelector('.w4-snap-upsell-expanded__price')?.textContent.trim();
      const originalPrice = priceBox.querySelector('.wizz-upsell-productInfor-content-priceBox-price-custom')?.textContent.trim();
      const sameVariant = source?.querySelector(selectSelector)?.value === card.querySelector(selectSelector)?.value;
      if (!sourceBadge || !compare || !price || compare === price || originalPrice !== compare || !sameVariant) {
        card.querySelector('.woshup-mobile-discount-badge')?.remove();
        priceBox.querySelector('.woshup-mobile-prices')?.remove();
        priceBox.removeAttribute('data-woshup-mobile-discount');
        continue;
      }
      let badge = card.querySelector('.woshup-mobile-discount-badge');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'woshup-mobile-discount-badge';
        card.appendChild(badge);
      }
      if (badge.textContent !== sourceBadge.textContent) badge.textContent = sourceBadge.textContent;
      badge.style.backgroundColor = getComputedStyle(sourceBadge).backgroundColor;
      badge.style.color = getComputedStyle(sourceBadge).color;
      let prices = priceBox.querySelector('.woshup-mobile-prices');
      if (!prices) {
        prices = document.createElement('span');
        prices.className = 'woshup-mobile-prices';
        for (const className of ['woshup-mobile-compare', 'woshup-mobile-price']) {
          const amount = document.createElement('span');
          amount.className = className;
          prices.appendChild(amount);
        }
        priceBox.appendChild(prices);
      }
      if (prices.children[0].textContent !== compare) prices.children[0].textContent = compare;
      if (prices.children[1].textContent !== price) prices.children[1].textContent = price;
      priceBox.setAttribute('data-woshup-mobile-discount', '');
    }
  }
  function update() {
    scheduled = false;
    const root = document.querySelector(rootSelector);
    if (!root) return;
    for (const card of root.querySelectorAll(cardSelector)) {
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) continue;
      const handle = new URL(link.href, location.href).pathname.split('/products/')[1]?.split('/')[0];
      const target = targets.get(handle);
      const targetId = variantIds.get(handle);
      if (!target) continue;
      const title = card.querySelector('.wizz-upsell-productInfor-content-title-custom');
      const shortTitle = titles.get(handle);
      if (title && shortTitle) {
        if (title.textContent !== shortTitle) title.textContent = shortTitle;
        title.setAttribute('title', shortTitle);
        title.setAttribute('data-woshup-upsell-title', '');
      }
      const addButton = card.querySelector('.w4-snap-upsell-expanded__add-icon');
      if (addButton && shortTitle) addButton.setAttribute('aria-label', shortTitle + ' hinzufügen');
      for (const select of card.querySelectorAll(selectSelector)) {
        if (!select.isConnected) continue;
        const option = Array.from(select.options).find(item => {
          const value = String(item.value || '');
          const text = String(item.textContent || '');
          const dataVariant = String(item.dataset?.variantId || '');
          return normalize(value) === normalize(target)
            || normalize(text) === normalize(target)
            || (targetId && value.includes(targetId))
            || (targetId && dataVariant.includes(targetId));
        });
        if (!option) {
          card.setAttribute('data-woshup-variant-missing', '');
          continue;
        }
        card.removeAttribute('data-woshup-variant-missing');
        if (select.value !== option.value) {
          setValue.call(select, option.value);
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (!select.isConnected) continue;
        for (const other of select.options) {
          if (other !== option) {
            other.hidden = true;
            other.disabled = true;
          }
        }
        select.disabled = true;
        select.setAttribute('data-woshup-fixed-variant', option.value);
        select.setAttribute('aria-label', target);
        const wrap = select.parentElement;
        wrap.setAttribute('data-woshup-variant-label-wrap', '');
        let label = wrap.querySelector('.woshup-variant-label');
        if (!label) {
          label = document.createElement('span');
          label.className = 'woshup-variant-label';
          wrap.appendChild(label);
        }
        const labelText = labels.get(handle) || target;
        if (label.textContent !== labelText) label.textContent = labelText;
      }
    }
    syncMobileDiscounts(root);
    for (const button of root.querySelectorAll('button[aria-label^="Remove "]')) {
      button.setAttribute('aria-label', button.getAttribute('aria-label').slice(7) + ' entfernen');
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }
  const observer = new MutationObserver(records => {
    if (records.some(record => {
      const target = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
      if (target?.closest(rootSelector)) return true;
      return Array.from(record.addedNodes).some(node => node.nodeType === Node.ELEMENT_NODE &&
        (node.matches(rootSelector) || node.querySelector(rootSelector)));
    })) schedule();
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  document.addEventListener('shopify:section:load', schedule);
  update();
})();
